<template>
    <v-row align="center" justify="center"
           class="confirmation-view">
        <v-col sm="8" md="4" xl="3">
            <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        DayToDay - Подтверждение почты
                    </v-toolbar-title>
                </v-toolbar>

                <v-card-text>
                    <div v-if="!isUrlValid"
                         class="text-error font-weight-bold">
                        Не удалось подтвердить почту: не передан код подтверждения или id пользователя.
                    </div>
                    <div v-else-if="!isEmailConfirmationSuccess"
                         class="text-error font-weight-bold">
                        {{errorMessage}}
                    </div>
                    <div v-else
                         class="text-success font-weight-bold">
                        Почта успешно подтверждена.
                    </div>

                    <div class="mt-2 mb-5">
                        <router-link :to="{ name: 'loginPage' }">
                            Перейти на страницу входа.
                        </router-link>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
        data() {
            return {
                errorMessage: "",
                isEmailConfirmationSuccess: false
            };
        },

        mounted() {
            if (this.isUrlValid) {
                const request = {
                    userId: this.userId,
                    code: this.code
                };

                this.$store.dispatch("confirmEmail", request).then(response => {
                    if (!response.data.isSuccess && !response.data.message) {
                        this.errorMessage = "Ошибка связи";
                        return;
                    }

                    if (!response.data.isSuccess) {
                        this.errorMessage = response.data.message;
                        return;
                    }

                    this.isEmailConfirmationSuccess = true;
                });
            }
        },

        computed: {
            userId() {
                return this.$route.query.userId;
            },
            code() {
                return this.$route.query.code;
            },
            isUrlValid() {
                return this.userId && this.code;
            }
        }
};
</script>
